import React from 'react';
export function GrainOverlay() {
  return <div className="pointer-events-none fixed inset-0 z-50 opacity-[0.12] mix-blend-screen" data-id="element-158">
      <svg className="h-full w-full" data-id="element-159">
        <filter id="noiseFilter" data-id="element-160">
          <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" stitchTiles="stitch" data-id="element-161" />
        </filter>
        <rect width="100%" height="100%" filter="url(#noiseFilter)" data-id="element-162" />
      </svg>
    </div>;
}